import { usePage } from '@inertiajs/react';
import { VideoLandingPage } from '@/components/public/VideoLandingPage';
import type { VideoLandingConfig } from '@/components/public/VideoLandingPage';

type PageProps = {
  videoProvider: 'youtube' | 'loom';
  videoId: string;
  [key: string]: unknown;
};

const RischiIa = () => {
  const { videoProvider, videoId } = usePage<PageProps>().props;

  const config: VideoLandingConfig = {
    pageTitle: "I rischi dell'IA senza controllo in psicologia — Emovia",
    badge: 'Sicurezza clinica',
    headline: "L'IA senza supervisione clinica è un rischio, non uno strumento",
    lead: 'Chatbot generalisti e strumenti AI non progettati per la clinica operano senza protezioni adeguate. Emovia è diverso: un diario guidato dove ogni interazione è sotto il tuo controllo, con blocchi di sicurezza attivi.',
    videoProvider,
    videoId,
    videoTitle: "Emovia — come funziona",
    supportCopy:
      'Per vedere come Emovia affronta questi rischi, guarda questo video di 3 minuti.',
    ctaLabel: 'Richiedi una demo',
    ctaLocation: 'landing_rischi_ia_cta',
  };

  return <VideoLandingPage config={config} />;
};

export default RischiIa;
